export var HdsIconlibraryMisc_24px;
(function (HdsIconlibraryMisc_24px) {
    HdsIconlibraryMisc_24px["AddAddressNumberOutline_24px"] = "add-address-number_outline_24px";
    HdsIconlibraryMisc_24px["AddAddressNumberSolid_24px"] = "add-address-number_solid_24px";
    HdsIconlibraryMisc_24px["AddressNumberOutline_24px"] = "address-number_outline_24px";
    HdsIconlibraryMisc_24px["AddressNumberSolid_24px"] = "address-number_solid_24px";
    HdsIconlibraryMisc_24px["BuildingHomeOutline_24px"] = "building-home_outline_24px";
    HdsIconlibraryMisc_24px["BuildingHomeSolid_24px"] = "building-home_solid_24px";
    HdsIconlibraryMisc_24px["BuildingOffOutline_24px"] = "building-off_outline_24px";
    HdsIconlibraryMisc_24px["BuildingOffSolid_24px"] = "building-off_solid_24px";
    HdsIconlibraryMisc_24px["BuildingOfficeOutline_24px"] = "building-office_outline_24px";
    HdsIconlibraryMisc_24px["BuildingOfficeSolid_24px"] = "building-office_solid_24px";
    HdsIconlibraryMisc_24px["CalculatorOutline_24px"] = "calculator_outline_24px";
    HdsIconlibraryMisc_24px["CalculatorSolid_24px"] = "calculator_solid_24px";
    HdsIconlibraryMisc_24px["CartOutline_24px"] = "cart_outline_24px";
    HdsIconlibraryMisc_24px["CartSolid_24px"] = "cart_solid_24px";
    HdsIconlibraryMisc_24px["CodeOutline_24px"] = "code_outline_24px";
    HdsIconlibraryMisc_24px["CodeSolid_24px"] = "code_solid_24px";
    HdsIconlibraryMisc_24px["CreditCardOutline_24px"] = "credit-card_outline_24px";
    HdsIconlibraryMisc_24px["CreditCardSolid_24px"] = "credit-card_solid_24px";
    HdsIconlibraryMisc_24px["DatasetOutline_24px"] = "dataset_outline_24px";
    HdsIconlibraryMisc_24px["DatasetSolid_24px"] = "dataset_solid_24px";
    HdsIconlibraryMisc_24px["ElevatorOutline_24px"] = "elevator_outline_24px";
    HdsIconlibraryMisc_24px["ElevatorSolid_24px"] = "elevator_solid_24px";
    HdsIconlibraryMisc_24px["EnvironmentOutline_24px"] = "environment_outline_24px";
    HdsIconlibraryMisc_24px["EnvironmentSolid_24px"] = "environment_solid_24px";
    HdsIconlibraryMisc_24px["EscalatorOutline_24px"] = "escalator_outline_24px";
    HdsIconlibraryMisc_24px["EscalatorSolid_24px"] = "escalator_solid_24px";
    HdsIconlibraryMisc_24px["EscalatorDownOutline_24px"] = "escalator-down_outline_24px";
    HdsIconlibraryMisc_24px["EscalatorDownSolid_24px"] = "escalator-down_solid_24px";
    HdsIconlibraryMisc_24px["EscalatorUpOutline_24px"] = "escalator-up_outline_24px";
    HdsIconlibraryMisc_24px["EscalatorUpSolid_24px"] = "escalator-up_solid_24px";
    HdsIconlibraryMisc_24px["ExpertOutline_24px"] = "expert_outline_24px";
    HdsIconlibraryMisc_24px["ExpertSolid_24px"] = "expert_solid_24px";
    HdsIconlibraryMisc_24px["FamilyOutline_24px"] = "family_outline_24px";
    HdsIconlibraryMisc_24px["FamilySolid_24px"] = "family_solid_24px";
    HdsIconlibraryMisc_24px["FlashlightOutline_24px"] = "flashlight_outline_24px";
    HdsIconlibraryMisc_24px["FlashlightSolid_24px"] = "flashlight_solid_24px";
    HdsIconlibraryMisc_24px["GlobalOutline_24px"] = "global_outline_24px";
    HdsIconlibraryMisc_24px["GlobalSolid_24px"] = "global_solid_24px";
    HdsIconlibraryMisc_24px["HandshakeOutline_24px"] = "handshake_outline_24px";
    HdsIconlibraryMisc_24px["HandshakeSolid_24px"] = "handshake_solid_24px";
    HdsIconlibraryMisc_24px["HardDriveOutline_24px"] = "hard-drive_outline_24px";
    HdsIconlibraryMisc_24px["HardDriveSolid_24px"] = "hard-drive_solid_24px";
    HdsIconlibraryMisc_24px["HeadphonesOutline_24px"] = "headphones_outline_24px";
    HdsIconlibraryMisc_24px["HeadphonesSolid_24px"] = "headphones_solid_24px";
    HdsIconlibraryMisc_24px["InboxOutline_24px"] = "inbox_outline_24px";
    HdsIconlibraryMisc_24px["InboxSolid_24px"] = "inbox_solid_24px";
    HdsIconlibraryMisc_24px["InboxAttentionOutline_24px"] = "inbox-attention_outline_24px";
    HdsIconlibraryMisc_24px["InboxAttentionSolid_24px"] = "inbox-attention_solid_24px";
    HdsIconlibraryMisc_24px["KeyOutline_24px"] = "key_outline_24px";
    HdsIconlibraryMisc_24px["KeySolid_24px"] = "key_solid_24px";
    HdsIconlibraryMisc_24px["KitchenOutline_24px"] = "kitchen_outline_24px";
    HdsIconlibraryMisc_24px["KitchenSolid_24px"] = "kitchen_solid_24px";
    HdsIconlibraryMisc_24px["LaboratoryOutline_24px"] = "laboratory_outline_24px";
    HdsIconlibraryMisc_24px["LaboratorySolid_24px"] = "laboratory_solid_24px";
    HdsIconlibraryMisc_24px["ManOutline_24px"] = "man_outline_24px";
    HdsIconlibraryMisc_24px["ManSolid_24px"] = "man_solid_24px";
    HdsIconlibraryMisc_24px["MeetingPointOutline_24px"] = "meeting-point_outline_24px";
    HdsIconlibraryMisc_24px["MeetingPointSolid_24px"] = "meeting-point_solid_24px";
    HdsIconlibraryMisc_24px["NeighbourhoodOutline_24px"] = "neighbourhood_outline_24px";
    HdsIconlibraryMisc_24px["NeighbourhoodSolid_24px"] = "neighbourhood_solid_24px";
    HdsIconlibraryMisc_24px["PacemakerOutline_24px"] = "pacemaker_outline_24px";
    HdsIconlibraryMisc_24px["PacemakerSolid_24px"] = "pacemaker_solid_24px";
    HdsIconlibraryMisc_24px["PeopleOutline_24px"] = "people_outline_24px";
    HdsIconlibraryMisc_24px["PeopleSolid_24px"] = "people_solid_24px";
    HdsIconlibraryMisc_24px["PoopOutline_24px"] = "poop_outline_24px";
    HdsIconlibraryMisc_24px["PoopSolid_24px"] = "poop_solid_24px";
    HdsIconlibraryMisc_24px["ProjectOutline_24px"] = "project_outline_24px";
    HdsIconlibraryMisc_24px["ProjectSolid_24px"] = "project_solid_24px";
    HdsIconlibraryMisc_24px["ProjectsOutline_24px"] = "projects_outline_24px";
    HdsIconlibraryMisc_24px["ProjectsSolid_24px"] = "projects_solid_24px";
    HdsIconlibraryMisc_24px["ReusableOutline_24px"] = "reusable_outline_24px";
    HdsIconlibraryMisc_24px["ReusableSolid_24px"] = "reusable_solid_24px";
    HdsIconlibraryMisc_24px["ServiceOutline_24px"] = "service_outline_24px";
    HdsIconlibraryMisc_24px["ServiceSolid_24px"] = "service_solid_24px";
    HdsIconlibraryMisc_24px["SparklesOutline_24px"] = "sparkles_outline_24px";
    HdsIconlibraryMisc_24px["SparklesSolid_24px"] = "sparkles_solid_24px";
    HdsIconlibraryMisc_24px["SparklesMicrophoneOutline_24px"] = "sparkles-microphone_outline_24px";
    HdsIconlibraryMisc_24px["SparklesMicrophoneSolid_24px"] = "sparkles-microphone_solid_24px";
    HdsIconlibraryMisc_24px["StairsOutline_24px"] = "stairs_outline_24px";
    HdsIconlibraryMisc_24px["StairsSolid_24px"] = "stairs_solid_24px";
    HdsIconlibraryMisc_24px["StopwatchOutline_24px"] = "stopwatch_outline_24px";
    HdsIconlibraryMisc_24px["StopwatchSolid_24px"] = "stopwatch_solid_24px";
    HdsIconlibraryMisc_24px["SuitcaseOutline_24px"] = "suitcase_outline_24px";
    HdsIconlibraryMisc_24px["SuitcaseSolid_24px"] = "suitcase_solid_24px";
    HdsIconlibraryMisc_24px["TerrainOutline_24px"] = "terrain_outline_24px";
    HdsIconlibraryMisc_24px["TerrainSolid_24px"] = "terrain_solid_24px";
    HdsIconlibraryMisc_24px["TicketBarrierOutline_24px"] = "ticket-barrier_outline_24px";
    HdsIconlibraryMisc_24px["TicketBarrierSolid_24px"] = "ticket-barrier_solid_24px";
    HdsIconlibraryMisc_24px["TrophyOutline_24px"] = "trophy_outline_24px";
    HdsIconlibraryMisc_24px["TrophySolid_24px"] = "trophy_solid_24px";
    HdsIconlibraryMisc_24px["VoiceCommandOutline_24px"] = "voice-command_outline_24px";
    HdsIconlibraryMisc_24px["VoiceCommandSolid_24px"] = "voice-command_solid_24px";
    HdsIconlibraryMisc_24px["WheelchairOutline_24px"] = "wheelchair_outline_24px";
    HdsIconlibraryMisc_24px["WheelchairSolid_24px"] = "wheelchair_solid_24px";
    HdsIconlibraryMisc_24px["WomanOutline_24px"] = "woman_outline_24px";
    HdsIconlibraryMisc_24px["WomanSolid_24px"] = "woman_solid_24px";
})(HdsIconlibraryMisc_24px = HdsIconlibraryMisc_24px || (HdsIconlibraryMisc_24px = {}));
export const HDS_ICONLIBRARY_MISC_24PX_CODEPOINTS = {
    [HdsIconlibraryMisc_24px.AddAddressNumberOutline_24px]: '61697',
    [HdsIconlibraryMisc_24px.AddAddressNumberSolid_24px]: '61698',
    [HdsIconlibraryMisc_24px.AddressNumberOutline_24px]: '61699',
    [HdsIconlibraryMisc_24px.AddressNumberSolid_24px]: '61700',
    [HdsIconlibraryMisc_24px.BuildingHomeOutline_24px]: '61701',
    [HdsIconlibraryMisc_24px.BuildingHomeSolid_24px]: '61702',
    [HdsIconlibraryMisc_24px.BuildingOffOutline_24px]: '61703',
    [HdsIconlibraryMisc_24px.BuildingOffSolid_24px]: '61704',
    [HdsIconlibraryMisc_24px.BuildingOfficeOutline_24px]: '61705',
    [HdsIconlibraryMisc_24px.BuildingOfficeSolid_24px]: '61706',
    [HdsIconlibraryMisc_24px.CalculatorOutline_24px]: '61707',
    [HdsIconlibraryMisc_24px.CalculatorSolid_24px]: '61708',
    [HdsIconlibraryMisc_24px.CartOutline_24px]: '61709',
    [HdsIconlibraryMisc_24px.CartSolid_24px]: '61710',
    [HdsIconlibraryMisc_24px.CodeOutline_24px]: '61711',
    [HdsIconlibraryMisc_24px.CodeSolid_24px]: '61712',
    [HdsIconlibraryMisc_24px.CreditCardOutline_24px]: '61713',
    [HdsIconlibraryMisc_24px.CreditCardSolid_24px]: '61714',
    [HdsIconlibraryMisc_24px.DatasetOutline_24px]: '61715',
    [HdsIconlibraryMisc_24px.DatasetSolid_24px]: '61716',
    [HdsIconlibraryMisc_24px.ElevatorOutline_24px]: '61717',
    [HdsIconlibraryMisc_24px.ElevatorSolid_24px]: '61718',
    [HdsIconlibraryMisc_24px.EnvironmentOutline_24px]: '61719',
    [HdsIconlibraryMisc_24px.EnvironmentSolid_24px]: '61720',
    [HdsIconlibraryMisc_24px.EscalatorOutline_24px]: '61721',
    [HdsIconlibraryMisc_24px.EscalatorSolid_24px]: '61722',
    [HdsIconlibraryMisc_24px.EscalatorDownOutline_24px]: '61723',
    [HdsIconlibraryMisc_24px.EscalatorDownSolid_24px]: '61724',
    [HdsIconlibraryMisc_24px.EscalatorUpOutline_24px]: '61725',
    [HdsIconlibraryMisc_24px.EscalatorUpSolid_24px]: '61726',
    [HdsIconlibraryMisc_24px.ExpertOutline_24px]: '61727',
    [HdsIconlibraryMisc_24px.ExpertSolid_24px]: '61728',
    [HdsIconlibraryMisc_24px.FamilyOutline_24px]: '61729',
    [HdsIconlibraryMisc_24px.FamilySolid_24px]: '61730',
    [HdsIconlibraryMisc_24px.FlashlightOutline_24px]: '61731',
    [HdsIconlibraryMisc_24px.FlashlightSolid_24px]: '61732',
    [HdsIconlibraryMisc_24px.GlobalOutline_24px]: '61733',
    [HdsIconlibraryMisc_24px.GlobalSolid_24px]: '61734',
    [HdsIconlibraryMisc_24px.HandshakeOutline_24px]: '61735',
    [HdsIconlibraryMisc_24px.HandshakeSolid_24px]: '61736',
    [HdsIconlibraryMisc_24px.HardDriveOutline_24px]: '61737',
    [HdsIconlibraryMisc_24px.HardDriveSolid_24px]: '61738',
    [HdsIconlibraryMisc_24px.HeadphonesOutline_24px]: '61739',
    [HdsIconlibraryMisc_24px.HeadphonesSolid_24px]: '61740',
    [HdsIconlibraryMisc_24px.InboxOutline_24px]: '61741',
    [HdsIconlibraryMisc_24px.InboxSolid_24px]: '61742',
    [HdsIconlibraryMisc_24px.InboxAttentionOutline_24px]: '61743',
    [HdsIconlibraryMisc_24px.InboxAttentionSolid_24px]: '61744',
    [HdsIconlibraryMisc_24px.KeyOutline_24px]: '61745',
    [HdsIconlibraryMisc_24px.KeySolid_24px]: '61746',
    [HdsIconlibraryMisc_24px.KitchenOutline_24px]: '61747',
    [HdsIconlibraryMisc_24px.KitchenSolid_24px]: '61748',
    [HdsIconlibraryMisc_24px.LaboratoryOutline_24px]: '61749',
    [HdsIconlibraryMisc_24px.LaboratorySolid_24px]: '61750',
    [HdsIconlibraryMisc_24px.ManOutline_24px]: '61751',
    [HdsIconlibraryMisc_24px.ManSolid_24px]: '61752',
    [HdsIconlibraryMisc_24px.MeetingPointOutline_24px]: '61753',
    [HdsIconlibraryMisc_24px.MeetingPointSolid_24px]: '61754',
    [HdsIconlibraryMisc_24px.NeighbourhoodOutline_24px]: '61755',
    [HdsIconlibraryMisc_24px.NeighbourhoodSolid_24px]: '61756',
    [HdsIconlibraryMisc_24px.PacemakerOutline_24px]: '61757',
    [HdsIconlibraryMisc_24px.PacemakerSolid_24px]: '61758',
    [HdsIconlibraryMisc_24px.PeopleOutline_24px]: '61759',
    [HdsIconlibraryMisc_24px.PeopleSolid_24px]: '61760',
    [HdsIconlibraryMisc_24px.PoopOutline_24px]: '61761',
    [HdsIconlibraryMisc_24px.PoopSolid_24px]: '61762',
    [HdsIconlibraryMisc_24px.ProjectOutline_24px]: '61763',
    [HdsIconlibraryMisc_24px.ProjectSolid_24px]: '61764',
    [HdsIconlibraryMisc_24px.ProjectsOutline_24px]: '61765',
    [HdsIconlibraryMisc_24px.ProjectsSolid_24px]: '61766',
    [HdsIconlibraryMisc_24px.ReusableOutline_24px]: '61767',
    [HdsIconlibraryMisc_24px.ReusableSolid_24px]: '61768',
    [HdsIconlibraryMisc_24px.ServiceOutline_24px]: '61769',
    [HdsIconlibraryMisc_24px.ServiceSolid_24px]: '61770',
    [HdsIconlibraryMisc_24px.SparklesOutline_24px]: '61771',
    [HdsIconlibraryMisc_24px.SparklesSolid_24px]: '61772',
    [HdsIconlibraryMisc_24px.SparklesMicrophoneOutline_24px]: '61773',
    [HdsIconlibraryMisc_24px.SparklesMicrophoneSolid_24px]: '61774',
    [HdsIconlibraryMisc_24px.StairsOutline_24px]: '61775',
    [HdsIconlibraryMisc_24px.StairsSolid_24px]: '61776',
    [HdsIconlibraryMisc_24px.StopwatchOutline_24px]: '61777',
    [HdsIconlibraryMisc_24px.StopwatchSolid_24px]: '61778',
    [HdsIconlibraryMisc_24px.SuitcaseOutline_24px]: '61779',
    [HdsIconlibraryMisc_24px.SuitcaseSolid_24px]: '61780',
    [HdsIconlibraryMisc_24px.TerrainOutline_24px]: '61781',
    [HdsIconlibraryMisc_24px.TerrainSolid_24px]: '61782',
    [HdsIconlibraryMisc_24px.TicketBarrierOutline_24px]: '61783',
    [HdsIconlibraryMisc_24px.TicketBarrierSolid_24px]: '61784',
    [HdsIconlibraryMisc_24px.TrophyOutline_24px]: '61785',
    [HdsIconlibraryMisc_24px.TrophySolid_24px]: '61786',
    [HdsIconlibraryMisc_24px.VoiceCommandOutline_24px]: '61787',
    [HdsIconlibraryMisc_24px.VoiceCommandSolid_24px]: '61788',
    [HdsIconlibraryMisc_24px.WheelchairOutline_24px]: '61789',
    [HdsIconlibraryMisc_24px.WheelchairSolid_24px]: '61790',
    [HdsIconlibraryMisc_24px.WomanOutline_24px]: '61791',
    [HdsIconlibraryMisc_24px.WomanSolid_24px]: '61792',
};
//# sourceMappingURL=hds-iconlibrary-misc-24px.js.map